import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export function useUpdateCustomPriceFreight() {
  const [loading, setLoading] = useState(false);
  async function execute(
    freightId: string,
    body: {
      freightCost: string;
    },
  ) {
    try {
      setLoading(true);
      const response = await api.patch(
        `v1/backoffice/freights/${freightId}/customPriceFreight`,
        {
          freightCost: body.freightCost,
        },
      );

      if (response.status === 200) {
        toast.success(ToastMessages.general.success.operationSuccess);
      }
    } catch (error) {
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }
  return { execute, loading };
}
